export default __webpack_public_path__ + "static/media/makeitbazar.d9d6201a.png";